/* BABYGO product pages: shared behaviour for the story template (pdp-*) and the standard template (std-*).
   Sticky offsets, smooth scrolling, sheets, galleries, clips, colour switching in place, sticky bars,
   "pairs well with" fill. Every section includes this file; the guard makes it run once. */
(function () {
  'use strict';
  if (window.__bgPdp) return;
  window.__bgPdp = true;

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function cssPx(name) {
    return parseFloat(getComputedStyle(root).getPropertyValue(name)) || 0;
  }
  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  /* ---------- Offsets: the theme header is position: sticky; the story nav sticks under it. ---------- */
  function measure() {
    var header = $('.header-section');
    var top = 0;
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') top = header.getBoundingClientRect().height;
    }
    root.style.setProperty('--pdp-sticky-top', top + 'px');
    root.style.setProperty('--bg-sticky-top', top + 'px');
    var nav = $('.pdp-nav-section');
    root.style.setProperty('--pdp-nav-h', (nav ? nav.getBoundingClientRect().height : 0) + 'px');
  }

  var frame = false;
  function onScroll() {
    if (frame) return;
    frame = true;
    requestAnimationFrame(function () {
      frame = false;
      measure();
      updateNavReveal();
      updateActiveLink();
      updateStickyBars();
    });
  }

  /* ---------- Smooth scroll to a section under the sticky header and nav. ---------- */
  function scrollToId(id, focus) {
    var el = document.getElementById(id);
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - cssPx('--pdp-sticky-top') - cssPx('--pdp-nav-h');
    window.scrollTo({ top: Math.max(0, y), behavior: reduced.matches ? 'auto' : 'smooth' });
    if (focus) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
    }
    return true;
  }
  function afterScroll(cb) {
    if (reduced.matches) { setTimeout(cb, 150); return; }
    var done = false;
    var finish = function () { if (done) return; done = true; window.removeEventListener('scrollend', finish); setTimeout(cb, 120); };
    if ('onscrollend' in window) window.addEventListener('scrollend', finish, { once: true });
    setTimeout(finish, 900);
  }

  /* ---------- Sheets and dialogs (story: .pdp-dialog, standard: .bgp-sheet). ---------- */
  function visibleVideoIn(d) {
    var vids = $all('video', d);
    for (var i = 0; i < vids.length; i++) if (vids[i].offsetParent !== null) return vids[i];
    return null;
  }
  var lastOpener = null;
  function openDialog(d, opener) {
    if (!d || typeof d.showModal !== 'function' || d.open) return;
    lastOpener = opener || document.activeElement;
    d.showModal();
    var panel = $('.bgp-sheet__panel', d);
    if (panel) panel.scrollTop = 0;
    document.body.classList.add('pdp-dialog-open');
    var v = visibleVideoIn(d);
    if (v && d.classList.contains('pdp-dialog')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    var focusable = $('.bgp-sheet__close, .pdp-dialog__close, [data-pdp-dialog-close]', d);
    if (focusable) focusable.focus({ preventScroll: true });
  }
  document.addEventListener('close', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DIALOG') return;
    document.body.classList.remove('pdp-dialog-open');
    $all('video', d).forEach(function (v) { v.pause(); });
    if (lastOpener && typeof lastOpener.focus === 'function') { try { lastOpener.focus({ preventScroll: true }); } catch (err) {} }
    lastOpener = null;
  }, true);
  document.addEventListener('click', function (e) {
    var d = e.target.closest('dialog.pdp-dialog, dialog.bgp-sheet');
    if (d && e.target === d) d.close();
  });
  /* Okendo opens its photo lightbox in #oke-modalContainer on <body>, which a modal dialog sits above and makes
     inert. Move it into the open dialog so it shows on top and works; Okendo removes it on close wherever it is.
     Escape then closes the lightbox only, not the sheet behind it. */
  if ('MutationObserver' in window) new MutationObserver(function (muts) {
    var open = $('dialog.pdp-dialog[open], dialog.bgp-sheet[open]');
    if (!open) return;
    muts.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.id === 'oke-modalContainer' && n.parentNode !== open) open.appendChild(n); });
    });
  }).observe(document.body, { childList: true });
  var okeEscapeAt = 0;
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var c = document.getElementById('oke-modalContainer');
    if (c && c.childNodes.length && c.closest('dialog[open]')) okeEscapeAt = Date.now();
  }, true);
  document.addEventListener('cancel', function (e) {
    if (e.target.tagName === 'DIALOG' && Date.now() - okeEscapeAt < 500) e.preventDefault();
  }, true);

  /* ---------- Click delegation: hash links, dialog openers and closers, story nav. ---------- */
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-pdp-dialog-close]');
    if (closer) { var cd = closer.closest('dialog'); if (cd) cd.close(); return; }

    var opener = e.target.closest('[data-pdp-dialog-open]');
    if (opener) {
      var od = document.getElementById(opener.getAttribute('data-pdp-dialog-open'));
      if (od && typeof od.showModal === 'function') { e.preventDefault(); openDialog(od, opener); }
      return;
    }

    var a = e.target.closest('.pdp a[href^="#"], .pdp-sticky a[href^="#"], .bgp a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (target && target.tagName === 'DIALOG' && typeof target.showModal === 'function') { e.preventDefault(); closeNav(); openDialog(target, a); return; }
    if (scrollToId(href.slice(1), true)) {
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', href);
      closeNav();
      var after = a.getAttribute('data-pdp-open-after');
      if (after) { var dlg = document.getElementById(after); if (dlg) afterScroll(function () { openDialog(dlg, a); }); }
    }
  });

  /* ---------- Story nav: mobile dropdown and active section. ---------- */
  var nav = $('.pdp-nav');
  var navLinks = nav ? $all('.pdp-nav__links a[href^="#"]', nav) : [];
  /* Links that open a dialog (the Awards link) have no place on the page, so they never go active. */
  var navTargets = navLinks.map(function (l) { var t = document.getElementById(l.getAttribute('href').slice(1)); return t && t.tagName === 'DIALOG' ? null : t; });
  function closeNav() {
    if (!nav) return;
    nav.classList.remove('is-open');
    var t = $('.pdp-nav__toggle', nav);
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  if (nav) {
    var toggle = $('.pdp-nav__toggle', nav);
    if (toggle) toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) { if (nav.classList.contains('is-open') && !nav.contains(e.target)) closeNav(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  }
  /* The nav bar can wait until the hero's Buy button has gone past the header. While it waits it is fixed
     and slid away, so it takes no space; anchors still allow for its height since it is shown by the time
     anyone scrolls to them. */
  var navSection = nav ? nav.closest('.pdp-nav-section') : null;
  var navReveal = !!(nav && nav.hasAttribute('data-pdp-nav-reveal'));
  if (navReveal && navSection) navSection.classList.add('is-reveal');
  function updateNavReveal() {
    if (!navReveal || !navSection) return;
    var btn = $('.pdp-hero .pdp-btn');
    var line = cssPx('--pdp-sticky-top');
    var show = btn ? btn.getBoundingClientRect().bottom < line : window.pageYOffset > 200;
    navSection.classList.toggle('is-shown', show);
    if (!show) closeNav();
  }
  function updateActiveLink() {
    if (!navLinks.length) return;
    var line = cssPx('--pdp-sticky-top') + cssPx('--pdp-nav-h') + 12;
    var current = null;
    navTargets.forEach(function (t) { if (t && t.getBoundingClientRect().top <= line) current = t; });
    navLinks.forEach(function (l) { l.classList.toggle('is-active', !!current && l.getAttribute('href') === '#' + current.id); });
  }

  /* ---------- Story hero video: play the visible variant, pause off screen. Nothing is downloaded for a visitor
     who asked for reduced motion or has data saver on; they keep the poster. ---------- */
  function bindHeroVideo(wrapper) {
    var variants = $all('[data-pdp-variant]', wrapper);
    if (!variants.length) return;
    var active = null, inView = true;
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    function visibleVideo() {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].offsetParent !== null || getComputedStyle(variants[i]).display !== 'none') { var v = $('video', variants[i]); if (v) return v; }
      }
      return null;
    }
    function sync() {
      var v = visibleVideo();
      if (v !== active) { if (active) active.pause(); active = v; }
      if (!active) return;
      if (inView && !reduced.matches && !saveData) { active.muted = true; var p = active.play(); if (p && p.catch) p.catch(function () {}); }
      else active.pause();
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; sync(); }, { threshold: 0.05 }).observe(wrapper);
    window.addEventListener('resize', sync);
    if (reduced.addEventListener) reduced.addEventListener('change', sync);
    sync();
  }

  /* ---------- Modes: three abstract SVG animations on one clock. Stimulation ripples outward, Expression draws
     in and releases, Massage kneads round the circle. The clock only advances while the section is on screen,
     the tab is visible and the visitor has not paused it, so resuming never jumps. Timings are visual, not
     pump measurements. ---------- */
  function bindModes(section) {
    if (section.__bound) return; section.__bound = true;
    var speed = parseFloat(section.getAttribute('data-speed')) || 1;
    var amp = parseFloat(section.getAttribute('data-amplitude')) || 1;
    var btn = $('[data-pdp-modes-toggle]', section);
    var playLabel = btn ? btn.getAttribute('data-label-play') : '', pauseLabel = btn ? btn.getAttribute('data-label-pause') : '';
    var stim = $all('[data-mode="stimulation"] [data-ring]', section), stimCore = $('[data-mode="stimulation"] [data-core]', section);
    var expr = $all('[data-mode="expression"] [data-ring]', section), exprCore = $('[data-mode="expression"] [data-core]', section);
    var mass = $all('[data-mode="massage"] [data-blob]', section);
    var elapsed = 0, last = null, raf = null, inView = false, paused = reduced.matches, wanted = !reduced.matches;
    var exprRest = [104, 90, 76, 62], exprPull = [18, 15, 12, 9], massBase = [94, 77, 60];
    function blobPath(base, i, phase) {
      var n = 80, d = '';
      for (var k = 0; k < n; k++) {
        var th = (k / n) * Math.PI * 2;
        var r = base + amp * (10 * Math.cos(2 * th - phase) + 2.7 * Math.sin(3 * th + 0.75 * phase + i));
        d += (k ? 'L' : 'M') + (120 + r * Math.cos(th)).toFixed(2) + ' ' + (120 + r * Math.sin(th)).toFixed(2);
      }
      return d + 'Z';
    }
    function draw(t) {
      stim.forEach(function (c, i) {
        var q = (t / 2.04 + i / 4) % 1;
        c.setAttribute('r', (37 + 73 * q).toFixed(2));
        c.setAttribute('opacity', (0.58 * Math.sin(Math.PI * q) * (1 - 0.55 * q)).toFixed(3));
      });
      if (stimCore) stimCore.setAttribute('r', (39.5 + 1.5 * amp * Math.cos(2 * Math.PI * t / 0.68)).toFixed(2));
      var pull = (1 - Math.cos(2 * Math.PI * t / 3.5)) / 2;
      expr.forEach(function (c, i) { c.setAttribute('r', (exprRest[i] - amp * exprPull[i] * pull).toFixed(2)); });
      if (exprCore) exprCore.setAttribute('r', (54 - amp * 13 * pull).toFixed(2));
      mass.forEach(function (pth, i) { pth.setAttribute('d', blobPath(massBase[i], i, 2 * Math.PI * t / 4.8 - i * 0.58)); });
    }
    function running() { return inView && wanted && !paused && !document.hidden; }
    function frame(now) {
      raf = null;
      if (!running()) { last = null; return; }
      if (last !== null) elapsed += Math.min(0.1, (now - last) / 1000) * speed;
      last = now;
      draw(elapsed);
      raf = requestAnimationFrame(frame);
    }
    function sync() {
      if (running()) { if (!raf) raf = requestAnimationFrame(frame); }
      else if (raf) { cancelAnimationFrame(raf); raf = null; last = null; }
      if (btn) { btn.textContent = paused ? playLabel : pauseLabel; btn.setAttribute('aria-pressed', paused ? 'true' : 'false'); }
    }
    draw(0);
    if (btn) btn.addEventListener('click', function () { paused = !paused; wanted = true; sync(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { inView = e[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(section);
    else { inView = true; sync(); }
    document.addEventListener('visibilitychange', sync);
    if (reduced.addEventListener) reduced.addEventListener('change', function () { if (reduced.matches) paused = true; sync(); });
    sync();
  }

  /* ---------- Clips: a still with the video behind it; tap on touch, hover on desktop, replay at the end. ---------- */
  function bindClip(el) {
    if (el.__bound) return; el.__bound = true;
    var v = $('video', el), btn = $('.pdp-clip__btn', el);
    if (!v || !btn) return;
    var state = 'idle';
    btn.setAttribute('data-label-play', btn.getAttribute('aria-label'));
    function set(s) {
      state = s;
      el.classList.toggle('is-playing', s === 'playing');
      el.classList.toggle('is-ended', s === 'ended');
      btn.setAttribute('aria-label', s === 'ended' ? 'Play again' : btn.getAttribute('data-label-play'));
    }
    function play() { state = 'loading'; var p = v.play(); if (p && p.catch) p.catch(function () { if (state === 'loading') set('idle'); }); }
    function restart() { try { v.currentTime = 0; } catch (err) {} play(); }
    function reset() { v.pause(); try { v.currentTime = 0; } catch (err) {} set('idle'); }
    v.addEventListener('playing', function () { if (state !== 'idle') set('playing'); else v.pause(); });
    v.addEventListener('ended', function () { set('ended'); });
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (state === 'ended') restart(); else if (state === 'idle') play(); });
    el.addEventListener('click', function () { if (state === 'ended') restart(); else if (state === 'idle') play(); });
    if (canHover.matches && !reduced.matches) {
      el.addEventListener('pointerenter', function (e) { if (e.pointerType && e.pointerType !== 'mouse') return; if (state === 'idle') play(); });
      el.addEventListener('pointerleave', function (e) { if (e.pointerType && e.pointerType !== 'mouse') return; if (state !== 'idle') reset(); });
    }
  }

  /* ---------- Galleries: a scroll-snap track with thumbnails (and dots on the standard page). ---------- */
  function bindTrackGallery(g, opts) {
    if (g.__bound) return; g.__bound = true;
    var track = $(opts.track, g);
    var slides = $all(opts.slide, g);
    var thumbs = $all(opts.thumb, g);
    var dots = opts.dot ? $all(opts.dot, g) : [];
    var strip = opts.strip ? $(opts.strip, g) : null;
    var current = 0;
    function setActive(i) {
      if (i < 0 || i >= slides.length) return;
      current = i;
      thumbs.forEach(function (t, j) { var on = j === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      slides.forEach(function (s, j) {
        var v = $('video', s);
        if (!v) return;
        if (j === i && opts.autoplayVideo) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (j !== i) v.pause();
      });
      if (strip && thumbs[i]) {
        var t = thumbs[i];
        if (strip.scrollHeight > strip.clientHeight) strip.scrollTo({ top: Math.max(0, t.offsetTop - (strip.clientHeight - t.offsetHeight) / 2), behavior: reduced.matches ? 'auto' : 'smooth' });
        else strip.scrollTo({ left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2), behavior: reduced.matches ? 'auto' : 'smooth' });
      }
    }
    function go(i) {
      if (track) track.scrollTo({ left: i * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var arrows = $all('[data-std-arrow]', g);
    function updateArrows() {
      arrows.forEach(function (a) {
        var dir = parseInt(a.getAttribute('data-std-arrow'), 10);
        var target = current + dir;
        a.disabled = target < 0 || target >= slides.length;
      });
    }
    arrows.forEach(function (a) { a.addEventListener('click', function () { go(current + parseInt(a.getAttribute('data-std-arrow'), 10)); updateArrows(); }); });
    g.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') { go(current - 1); updateArrows(); e.preventDefault(); }
      if (e.key === 'ArrowRight') { go(current + 1); updateArrows(); e.preventDefault(); }
    });
    var thumbNav = $all('[data-std-thumbs]', g);
    function updateThumbNav() {
      if (!strip || !thumbNav.length) return;
      var overflow = strip.scrollHeight > strip.clientHeight + 2;
      thumbNav.forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-std-thumbs'), 10);
        var can = overflow && (dir < 0 ? strip.scrollTop > 2 : strip.scrollTop + strip.clientHeight < strip.scrollHeight - 2);
        b.hidden = !can;
      });
    }
    thumbNav.forEach(function (b) { b.addEventListener('click', function () { if (!strip) return; strip.scrollBy({ top: parseInt(b.getAttribute('data-std-thumbs'), 10) * strip.clientHeight * 0.8, behavior: reduced.matches ? 'auto' : 'smooth' }); }); });
    if (strip) { strip.addEventListener('scroll', function () { requestAnimationFrame(updateThumbNav); }, { passive: true }); window.addEventListener('resize', updateThumbNav); }
    updateArrows(); updateThumbNav();
    if (window.requestAnimationFrame) requestAnimationFrame(updateThumbNav);
    window.addEventListener('load', updateThumbNav);
    if (track) {
      var pending = false;
      track.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) { setActive(i); updateArrows(); }
        });
      }, { passive: true });
    }
    g.__goToMedia = function (mediaId) {
      var idx = -1;
      slides.forEach(function (s, j) { if (String(s.getAttribute('data-media-id')) === String(mediaId)) idx = j; });
      if (idx >= 0) go(idx);
    };
  }

  /* ---------- Zoom (standard gallery) with the theme's PhotoSwipe. ---------- */
  function bindZoom(g) {
    var track = $('[data-std-track]', g);
    if (!track) return;
    track.addEventListener('click', function (e) {
      var slide = e.target.closest('.std-gallery__slide[data-zoom-src]');
      if (!slide || typeof window.PhotoSwipe === 'undefined' || typeof window.PhotoSwipeUI_Default === 'undefined') return;
      if (e.target.closest('video, button, a')) return;
      var pswp = $('.pswp');
      if (!pswp) return;
      var zoomable = $all('.std-gallery__slide[data-zoom-src]', g);
      var items = zoomable.map(function (s) { return { src: s.getAttribute('data-zoom-src'), w: parseInt(s.getAttribute('data-zoom-w'), 10) || 2048, h: parseInt(s.getAttribute('data-zoom-h'), 10) || 2048 }; });
      var index = zoomable.indexOf(slide);
      try {
        var gallery = new window.PhotoSwipe(pswp, window.PhotoSwipeUI_Default, items, { index: index, bgOpacity: 1, history: false, shareEl: false, fullscreenEl: false, closeOnScroll: false, showHideOpacity: true });
        gallery.init();
      } catch (err) {}
    });
  }

  /* ---------- Sticky bars (story .pdp-sticky, standard .std-sticky). ---------- */
  function updateStickyBars() {
    var narrow = window.innerWidth < 1024;
    var storyBar = $('.pdp-sticky');
    if (storyBar) {
      var heroActions = $('.pdp-hero__actions'), buyPanel = $('.pdp-buy__panel');
      var show = window.innerWidth < 900;
      if (show && heroActions) show = heroActions.getBoundingClientRect().bottom < 0;
      if (show && buyPanel) show = buyPanel.getBoundingClientRect().top > window.innerHeight - 80;
      storyBar.classList.toggle('is-shown', show);
    }
    var stdBar = $('[data-std-sticky]');
    if (stdBar) {
      var actions = $('.std-actions');
      var on = narrow && !!actions && actions.getBoundingClientRect().bottom < 0;
      stdBar.classList.toggle('is-shown', on);
      stdBar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $all('button', stdBar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      document.body.classList.toggle('std-sticky-space', on);
    }
  }

  /* ---------- Standard page: sticky bar size label and gallery follow the variant. ---------- */
  function sizeLabelFor(variant, main) {
    if (!variant) return '';
    var fieldsets = $all('fieldset[data-handle]', main);
    var idx = -1;
    fieldsets.forEach(function (f, i) { if (idx < 0 && /size/.test(f.getAttribute('data-handle') || '')) idx = i; });
    if (idx >= 0 && variant.options && variant.options[idx]) return ', ' + variant.options[idx];
    if (fieldsets.length && variant.title && variant.title !== 'Default Title') return ', ' + variant.title;
    return '';
  }
  /* ---------- Preorder per variant (Gavin, 20 Oct 2026). std-main writes a map of variant id to the note and the
     order line for every variant on preorder. The form's template attribute drives the button label here and in the
     theme's product.js, so both say "Preorder" for those variants and "Add to bag" for the rest. ---------- */
  function setPreorder(main, variant) {
    var el = $('[data-std-preorder]', main);
    if (!el) return;
    var map = {};
    try { map = JSON.parse(el.textContent) || {}; } catch (err) { map = {}; }
    var pre = map[String(variant.id)];
    var form = $('.product-form', main);
    if (form) form.setAttribute('template', pre ? 'pre-order' : (form.getAttribute('data-std-base-template') || ''));
    var note = $('[data-std-preorder-note]', main);
    var text = $('[data-std-preorder-text]', main);
    var prop = $('[data-std-preorder-prop]', main);
    if (note) note.hidden = !pre;
    if (text && pre) text.textContent = pre.note;
    if (prop) { prop.disabled = !pre; if (pre) prop.value = pre.prop; }
  }

  document.addEventListener('product:variant-change', function (e) {
    var variant = e.detail && e.detail.variant;
    var main = $('[data-std-main]');
    if (!main || !variant) return;
    setPreorder(main, variant);
    var size = $('[data-std-sticky-size]', main);
    if (size) size.textContent = sizeLabelFor(variant, main);
    var g = $('[data-std-gallery]', main);
    if (g && g.__goToMedia && variant.featured_media && variant.featured_media.id) g.__goToMedia(variant.featured_media.id);
    updateDeliveryLine(main, variant);
    refreshAvailability(main);
    setButtonState(main, variant);
  });

  /* ---------- The buy buttons show their final state at once. The theme disables them while it fetches the
     new price and re-enables them afterwards; the grey look is tied to the real sold-out state only. ---------- */
  function setButtonState(main, variant) {
    var strings = (window.theme && window.theme.variantStrings) || {};
    var form = $('.product-form', main);
    var preorder = form && /pre-order/.test(form.getAttribute('template') || '');
    var label = variant.available ? (preorder ? (strings.preOrder || 'Pre-order') : (strings.addToCart || 'Add to bag')) : (strings.soldOut || 'Sold out');
    $all('.single-add-to-cart-button', main).forEach(function (b) {
      b.classList.remove('sold-out');
      b.classList.toggle('is-sold-out', !variant.available);
      var t = $('.single-add-to-cart-button--text', b);
      if (t && !b.classList.contains('loading')) t.textContent = label;
    });
  }

  /* ---------- Standard page: the delivery line follows the variant price. ---------- */
  /* The line says "Free UK delivery" when the variant alone qualifies or the bag already does (Gavin, 25 Sep 2026).
     The bag total starts from the page render and is re-read from /cart.js after any cart write. */
  var cartTotal = null;
  function readCartTotal(scope) {
    var n = $('[data-std-notes][data-cart-total], [data-pdp-delivery][data-cart-total]', scope || document);
    if (n) { var v = parseInt(n.getAttribute('data-cart-total'), 10); if (!isNaN(v)) cartTotal = v; }
  }
  function refreshDeliveryLines() {
    $all('[data-std-main]').forEach(function (m) {
      var vs = $('variant-selects', m);
      if (vs && vs.currentVariant) updateDeliveryLine(m, vs.currentVariant);
    });
    /* Story hero: the line carries its own price and texts. */
    $all('[data-pdp-delivery]').forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-threshold'), 10), price = parseInt(el.getAttribute('data-price'), 10);
      if (!threshold || isNaN(price)) return;
      var free = price >= threshold || (cartTotal !== null && cartTotal >= threshold);
      el.textContent = free ? el.getAttribute('data-free-text') : el.getAttribute('data-delivery-text');
    });
  }
  function refreshCartTotal() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.total_price === 'number') { cartTotal = c.total_price; refreshDeliveryLines(); } })
      .catch(function () {});
  }
  ['cart:item-added', 'line-item:change:end', 'cart:refresh', 'cart:updated'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(refreshCartTotal, 150); });
  });
  if (window.fetch && !window.fetch.__bgCartWatch) {
    var nativeFetch = window.fetch;
    var watched = function (input, init) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function () { setTimeout(refreshCartTotal, 200); }, function () {});
      } catch (err) {}
      return p;
    };
    watched.__bgCartWatch = true;
    window.fetch = watched;
  }
  function updateDeliveryLine(main, variant) {
    var notes = $('[data-std-notes]', main);
    var line = notes ? $('[data-std-delivery]', notes) : null;
    var threshold = notes ? parseInt(notes.getAttribute('data-threshold'), 10) : 0;
    if (!line || !threshold || typeof variant.price !== 'number') return;
    var free = variant.price >= threshold || (cartTotal !== null && cartTotal >= threshold);
    line.textContent = free ? notes.getAttribute('data-free-text') : notes.getAttribute('data-delivery-text');
  }

  /* ---------- Standard page: a value is struck through only when no in-stock variant has it together
     with the other chosen values. The theme's own pass strikes the chosen values themselves when the
     combination is sold out, which reads as everything being sold out, so this runs after it. ---------- */
  function variantsFor(main) {
    if (main.__variants) return main.__variants;
    var json = $('variant-selects script[type="application/json"]', main);
    try { main.__variants = JSON.parse(json.textContent); } catch (err) { main.__variants = []; }
    return main.__variants;
  }
  function refreshAvailability(main) {
    var vs = $('variant-selects', main);
    if (!vs) return;
    var variants = variantsFor(main);
    if (!variants.length) return;
    var fieldsets = $all('fieldset[data-index]', vs);
    var selected = fieldsets.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
    fieldsets.forEach(function (f, i) {
      $all('input[type="radio"]', f).forEach(function (input) {
        var ok = variants.some(function (v) {
          if (!v.available || !v.options || v.options[i] !== input.value) return false;
          for (var j = 0; j < i; j++) { if (selected[j] !== null && v.options[j] !== selected[j]) return false; }
          return true;
        });
        if (input.classList.contains('is-disabled') === !ok) { /* already right */ } else { input.classList.toggle('is-disabled', !ok); }
        var label = input.nextElementSibling;
        if (label && label.classList.contains('std-capsule')) {
          var sr = $('.std-capsule__sr', label);
          if (!ok && !sr) { sr = document.createElement('span'); sr.className = 'bgp-visually-hidden std-capsule__sr'; sr.textContent = ', sold out'; label.appendChild(sr); }
          else if (ok && sr) sr.parentNode.removeChild(sr);
        }
      });
    });
  }
  function watchAvailability(main) {
    var vs = $('variant-selects', main);
    if (!vs || vs.__availWatch) return;
    vs.__availWatch = true;
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; refreshAvailability(main); });
      }).observe(vs, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    refreshAvailability(main);
  }

  /* ---------- Standard page: an add-to-bag error must be seen, also when it came from the sticky bar. ---------- */
  function watchErrors(main) {
    var wrap = $('.product-form__error-message-wrapper', main);
    if (!wrap || wrap.__watched || !window.MutationObserver) return;
    wrap.__watched = true;
    new MutationObserver(function () {
      if (wrap.hidden) return;
      var bar = $('[data-std-sticky]');
      var barH = bar && bar.classList.contains('is-shown') ? bar.getBoundingClientRect().height : 0;
      var r = wrap.getBoundingClientRect();
      if (r.top < cssPx('--pdp-sticky-top') || r.bottom > window.innerHeight - barH) {
        wrap.scrollIntoView({ block: 'center', behavior: reduced.matches ? 'auto' : 'smooth' });
      }
    }).observe(wrap, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* ---------- One add at a time: a second submit while the first is in flight is dropped. ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if ($('.single-add-to-cart-button.loading')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* ---------- Standard page: expose the product for Klaviyo's onsite scripts after a swap. ---------- */
  function exposeProduct(main) {
    var json = $('[data-std-product]', main);
    if (!json) return;
    try { window.product = JSON.parse(json.textContent); } catch (err) {}
  }

  /* ---------- Colour switching: each colour is its own product, so the buy section is re-rendered
     through section rendering and swapped in place. Links still work without JavaScript. ---------- */
  function markSelected(handle) {
    $all('.pdp-colour').forEach(function (li) {
      var a = $('[data-pdp-select]', li);
      var on = !!a && a.getAttribute('data-handle') === handle;
      li.classList.toggle('is-selected', on);
      if (a) { if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); }
    });
  }
  function currentSelection(main) {
    var sel = {};
    $all('fieldset[data-handle]', main).forEach(function (f) {
      var checked = $('input:checked', f);
      if (checked) sel[f.getAttribute('data-handle')] = checked.value;
    });
    return sel;
  }
  function restoreSelection(main, sel) {
    var changed = false;
    Object.keys(sel).forEach(function (handle) {
      var f = $('fieldset[data-handle="' + handle + '"]', main);
      if (!f) return;
      var input = $all('input', f).filter(function (i) { return i.value === sel[handle]; })[0];
      if (input && !input.checked) { input.checked = true; changed = true; }
    });
    if (changed) {
      var vs = $('variant-selects', main);
      if (vs) vs.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  var switching = false;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pdp-select], [data-std-select]');
    if (!a) return;
    var rootEl = $('[data-std-main], [data-pdp-buy]');
    if (!rootEl || !window.fetch || !window.DOMParser) return;
    var url = a.getAttribute('data-pdp-select') || a.getAttribute('data-std-select');
    var handle = a.getAttribute('data-handle');
    if (!url || !handle) return;
    e.preventDefault();
    if (handle === rootEl.getAttribute('data-product-handle')) { markSelected(handle); return; }
    if (switching) return;
    switching = true;
    var isStd = rootEl.hasAttribute('data-std-main');
    var selection = isStd ? currentSelection(rootEl) : null;
    rootEl.classList.add('is-switching');
    rootEl.setAttribute('aria-busy', 'true');
    var sid = rootEl.getAttribute('data-section-id');
    var view = rootEl.getAttribute('data-view');
    var viewQs = view ? '&view=' + encodeURIComponent(view) : '';
    var wrappers = isStd ? stdSectionWrappers() : [];
    var request;
    if (isStd && wrappers.length) {
      var ids = wrappers.map(function (w) { return w.id.replace(/^shopify-section-/, ''); });
      request = fetch(url + '?sections=' + encodeURIComponent(ids.join(',')) + viewQs, { headers: { 'Accept': '*/*' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          var docs = {};
          var mainDoc = null;
          wrappers.forEach(function (w) {
            var key = w.id.replace(/^shopify-section-/, '');
            if (typeof data[key] !== 'string') return;
            docs[w.id] = new DOMParser().parseFromString(data[key], 'text/html');
            if ($('[data-std-main]', docs[w.id])) mainDoc = docs[w.id];
          });
          if (!mainDoc) throw new Error('missing');
          /* The new colour's first photo is fetched before anything is swapped, so the gallery never
             shows an empty stage while the image downloads. Thumbnails are warmed in the background. */
          return preloadGallery(mainDoc).then(function () {
            var mainNode = null;
            wrappers.forEach(function (w) {
              var doc = docs[w.id];
              if (!doc) return;
              var fresh = doc.getElementById(w.id) || doc.body;
              w.innerHTML = fresh.innerHTML;
              var m = $('[data-std-main]', w);
              if (m) mainNode = m;
            });
            return mainNode;
          });
        });
    } else {
      request = fetch(url + '?section_id=' + encodeURIComponent(sid) + viewQs, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-std-main], [data-pdp-buy]', doc);
          if (!fresh) throw new Error('missing');
          var node = document.importNode(fresh, true);
          var current = $('[data-std-main], [data-pdp-buy]');
          var wrapper = current.parentNode;
          current.replaceWith(node);
          var oldLd = $('script[type="application/ld+json"]', wrapper);
          var newLd = $('script[type="application/ld+json"]', doc);
          if (oldLd && newLd) { var s = document.createElement('script'); s.type = 'application/ld+json'; s.textContent = newLd.textContent; oldLd.replaceWith(s); }
          return node;
        });
    }
    request
      .then(function (node) {
        var vs = $('variant-selects', node);
        if (vs) vs.other = [];
        if (isStd) {
          wrappers.forEach(function (w) { init(w); });
          exposeProduct(node);
          restoreSelection(node, selection);
          refreshAvailability(node);
          if (window.okeWidgetApi && typeof window.okeWidgetApi.initWidget === 'function') {
            wrappers.forEach(function (w) { $all('[data-oke-widget]', w).forEach(function (el) { try { window.okeWidgetApi.initWidget(el); } catch (err) {} }); });
          }
        } else {
          init(node);
        }
        markSelected(handle);
        var docTitle = node.getAttribute('data-document-title');
        if (docTitle) document.title = docTitle;
        if (history.replaceState && window.URLSearchParams) {
          var params = new URLSearchParams(location.search);
          params.delete('variant');
          var idInput = $('input[name="id"]', node);
          if ($('variant-selects', node) && idInput && idInput.value) params.set('variant', idInput.value);
          var qs = params.toString();
          history.replaceState(null, '', url + (qs ? '?' + qs : '') + location.hash);
        }
      })
      .catch(function (err) {
        if (window.console && console.warn) console.warn('Colour switch fell back to a page load:', err);
        location.href = url + (rootEl.id ? '#' + rootEl.id : '');
      })
      .then(function () {
        switching = false;
        var b = $('[data-std-main], [data-pdp-buy]');
        if (b) { b.classList.remove('is-switching'); b.removeAttribute('aria-busy'); }
        onScroll();
      });
  });
  function preloadGallery(doc) {
    var first = $('[data-std-track] .std-gallery__slide picture, [data-std-track] .std-gallery__slide img', doc);
    var thumbs = $all('.std-gallery__thumbs img', doc).slice(0, 8);
    function warmThumbs() {
      thumbs.forEach(function (t) {
        var warm = new Image();
        if (t.getAttribute('srcset')) warm.srcset = t.getAttribute('srcset');
        warm.src = t.getAttribute('src');
      });
    }
    if (!first) { warmThumbs(); return Promise.resolve(); }
    return new Promise(function (resolve) {
      var done = false;
      var holder = document.createElement('div');
      holder.setAttribute('aria-hidden', 'true');
      holder.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;';
      var clone = document.importNode(first, true);
      var img = clone.tagName === 'IMG' ? clone : $('img', clone);
      function finish() { if (done) return; done = true; if (holder.parentNode) holder.parentNode.removeChild(holder); warmThumbs(); resolve(); }
      if (!img) { finish(); return; }
      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', 'high');
      img.addEventListener('load', function () { if (img.decode) { img.decode().then(finish, finish); } else { finish(); } });
      img.addEventListener('error', finish);
      holder.appendChild(clone);
      document.body.appendChild(holder);
      setTimeout(finish, 3000);
      if (img.complete && img.naturalWidth) finish();
    });
  }
  function stdSectionWrappers() {
    var out = [];
    $all('.shopify-section').forEach(function (w) {
      if (!/^shopify-section-/.test(w.id)) return;
      if (/__(main|story|highlights|details|pairs)$/.test(w.id) || $('[data-std-main], .std-story, .std-highlights, .std-details, .std-pairs', w)) out.push(w);
    });
    return out;
  }

  /* ---------- Pairs well with: complementary picks first, then related products fill the row. ---------- */
  function bindPairs(section) {
    if (section.__bound) return; section.__bound = true;
    var track = $('[data-std-pairs-track]', section);
    var navEl = $('[data-std-pairs-nav]', section);
    if (!track) return;
    var max = parseInt(section.getAttribute('data-max'), 10) || 8;
    var exclude = (section.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    var group = section.getAttribute('data-group') || '';
    function have() { return $all('[data-handle]', track).map(function (li) { return li.getAttribute('data-handle'); }); }
    function groups() { return $all('[data-handle]', track).map(function (li) { return li.getAttribute('data-group') || li.getAttribute('data-handle'); }); }
    /* Tiles already shown by another pairs row on the page (e.g. "Pairs well with" above "You might also like") */
    function elsewhere() { return $all('[data-std-pairs] [data-handle]').filter(function (li) { return !track.contains(li); }).map(function (li) { return li.getAttribute('data-group') || li.getAttribute('data-handle'); }); }
    function updateNav() {
      if (!navEl) return;
      var overflow = track.scrollWidth > track.clientWidth + 4;
      navEl.hidden = !overflow;
      var prev = $('[data-dir="-1"]', navEl), next = $('[data-dir="1"]', navEl);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (navEl) navEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dir]');
      if (!b) return;
      track.scrollBy({ left: parseInt(b.getAttribute('data-dir'), 10) * track.clientWidth, behavior: reduced.matches ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', function () { requestAnimationFrame(updateNav); }, { passive: true });
    window.addEventListener('resize', updateNav);
    var url = section.getAttribute('data-url');
    if (url && window.fetch && have().length < max) {
      fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var seen = have();
          var seenGroups = groups().concat(elsewhere());
          $all('.std-pairs__fragment > li', doc).forEach(function (li) {
            var h = li.getAttribute('data-handle');
            var gr = li.getAttribute('data-group') || h;
            if (!h || seen.indexOf(h) >= 0 || exclude.indexOf(h) >= 0) return;
            if (li.getAttribute('data-available') === 'false') return;
            if (gr === group || seenGroups.indexOf(gr) >= 0) return;
            if (have().length >= max) return;
            track.appendChild(document.importNode(li, true));
            seen.push(h);
            seenGroups.push(gr);
          });
        })
        .catch(function () {})
        .then(function () { updateNav(); if (!have().length) section.hidden = true; });
    } else {
      if (!have().length) section.hidden = true;
      updateNav();
    }
  }

  /* ---------- Tabs (std-tabs): one strip, one panel; arrows move between tabs. ---------- */
  function selectTab(tab) {
    var root = tab.closest('[data-std-tabs]'); if (!root) return;
    var key = tab.getAttribute('data-std-tab');
    $all('[data-std-tab]', root).forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); if (on) t.removeAttribute('tabindex'); else t.setAttribute('tabindex', '-1'); });
    $all('[data-std-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-std-panel') !== key; });
    if (typeof tab.scrollIntoView === 'function') tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-std-tab]'); if (!tab) return;
    selectTab(tab); onScroll();
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-std-tab]'); if (!tab) return;
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
    var tabs = $all('[data-std-tab]', tab.closest('[data-std-tabs]')); var i = tabs.indexOf(tab);
    if (e.key === 'ArrowRight') i = (i + 1) % tabs.length; else if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length; else if (e.key === 'Home') i = 0; else i = tabs.length - 1;
    e.preventDefault(); tabs[i].focus(); selectTab(tabs[i]);
  });

  /* ---------- Init everything inside a scope (the document, or a swapped section). ---------- */
  function init(scope) {
    $all('[data-pdp-hero-video]', scope).forEach(function (w) { if (!w.__bound) { w.__bound = true; bindHeroVideo(w); } });
    $all('[data-pdp-clip]', scope).forEach(bindClip);
    $all('[data-pdp-modes]', scope).forEach(bindModes);
    $all('[data-pdp-gallery]', scope).forEach(function (g) { bindTrackGallery(g, { track: '.pdp-gallery__track', slide: '.pdp-gallery__slide', thumb: '.pdp-thumb', strip: '.pdp-gallery__thumbs', autoplayVideo: true }); });
    $all('[data-std-gallery]', scope).forEach(function (g) { bindTrackGallery(g, { track: '[data-std-track]', slide: '.std-gallery__slide', thumb: '.std-thumb', dot: '.std-gallery__dots button', strip: '.std-gallery__thumbs', autoplayVideo: false }); bindZoom(g); });
    $all('[data-std-pairs]', scope).forEach(bindPairs);
    var main = scope.matches && scope.matches('[data-std-main]') ? scope : $('[data-std-main]', scope);
    if (main) {
      readCartTotal(main);
      var vsel = $('variant-selects', main);
      if (vsel && vsel.currentVariant) updateDeliveryLine(main, vsel.currentVariant);
      var size = $('[data-std-sticky-size]', main);
      var vs = $('variant-selects', main);
      if (size && vs && vs.currentVariant) size.textContent = sizeLabelFor(vs.currentVariant, main);
      watchAvailability(main);
      watchErrors(main);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);
  measure();
  window.bgPdp = window.bgPdp || {}; window.bgPdp.init = init;
  init(document);
  readCartTotal(document);
  refreshCartTotal();
  updateNavReveal();
  updateActiveLink();
  updateStickyBars();

  if (location.hash && location.hash.length > 1 && !document.getElementById(location.hash.slice(1).replace(/^$/, '-'))) { /* no-op */ }
  if (location.hash && location.hash.length > 1) {
    var hashTarget = document.getElementById(location.hash.slice(1));
    if (hashTarget && hashTarget.tagName === 'DIALOG') window.addEventListener('load', function () { setTimeout(function () { openDialog(hashTarget, null); }, 250); });
    else if (hashTarget) window.addEventListener('load', function () { setTimeout(function () { scrollToId(location.hash.slice(1), false); }, 60); });
  }
})();
